import { t } from "@lingui/core/macro";
const searchDeals = (params, onSuccess, onError) => {
  const { phrase, categoryKey, distance, redemptionMethod, perPage, page } = params;

  const url = `https://deals-api-stage.accessdevelopment.com/v1/search?
      phrase=${phrase}&
      category_key=${categoryKey}&
      distance=${distance}&
      redemption_method=${redemptionMethod}&
      per_page=${perPage}&
      page=${page}`.replace(/\s/g, "");

  const promise = fetch(url, {
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(t`Something went wrong`);
    }
  });

  promise
    .then((data) => {
      if (data) {
        onSuccess(data);
      }
    })
    .catch((error) => {
      onError(error);
    });
};

export default {
  searchDeals,
};
